function SentinelRadioManualFieldsChange(
  option: any,
  setFieldValue: Function,
  setFieldTouched: Function
) {

  if (option.label === "I don't know" || option.value == "No") {
    setFieldTouched("lymphNodeStatus", true);
    setFieldValue("lymphNodeStatus", "", true);
  }
}
export default SentinelRadioManualFieldsChange;
